module.exports = __webpack_public_path__ + "static/media/close-homepage.693c1c17.svg";